import BasketOrderItemCheckoutPrice from "../../../entities/manhattan/basket/BasketOrderItemCheckoutPrice";
import { IBasketOrderItemPrice } from "../../../entities/manhattan/order/types";
import { IManhattanFactory } from "../types";


export const BasketOrderItemCheckoutPriceFactory: IManhattanFactory = class BasketOrderItemPriceFactory {

  static create(basketOrderItemPrice: IBasketOrderItemPrice) {
    const amountToPay = basketOrderItemPrice.amount;

    return new BasketOrderItemCheckoutPrice(
      amountToPay,
    );
  }

};
